<template>
  <div class="mobile-menu">
    <div class="mobile-menu__header flex items-center">
      <button
        type="button"
        class="pa-24px bn bg-transparent outline-0 fw6"
        :class="this.lightBg === 'true' ? 'dark shop-color-2' : 'light shop-color-2'"
        @click="toggleLocationList"
        v-if="isOpen"
      >
        {{ translations.chooseLocation }}
        <span class="ph2 color-2">
          <svg
            class="v-mid dib"
            :class="showLocations ? 'rotate-270' : 'rotate-90'"
            height="12"
            viewBox="0 0 7 12"
            width="7"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <g fill="none" fill-rule="evenodd" transform="translate(-13 -10)">
              <path
                fill="currentColor"
                d="m13.2191312 20.375305 1.5617376 1.24939 4.499756-5.624695-4.499756-5.624695-1.5617376 1.24939 3.500244 4.375305z"
              />
            </g>
          </svg>
        </span>
      </button>
      <div class="ph3 pv2 mobile-menu__logo" v-else>
        <slot name="logo"></slot>
      </div>

      <div class="ml-auto w3 pt2 pr0 pb2 pl3">
        <slot name="button-tel"></slot>
      </div>

      <button
        type="button"
        role="button"
        class="bg-transparent outline-0 bn pointer pa-24px"
        :class="isOpen ? 'color-2' : 'light shop-color-2'"
        @click="toggle"
      >
        <slot name="button-icon-close" v-if="isOpen"></slot>
        <slot name="button-icon-open" v-else></slot>
      </button>
    </div>

    <transition @enter="onEnter" @leave="onLeave" :css="false">
      <div class="mobile-menu__content" v-if="isOpen">
        <div v-if="showLocations" class="pt-73px">
          <a v-for="(location, i) in locations" :href="location.url" :key="`location-${i}`">
            <div class="aspect-ratio aspect-ratio--5x2">
              <div
                class="aspect-ratio--object flex items-center cover ph3"
                :style="{ backgroundImage: `url('${location.imageMobile}')` }"
              >
                <h4
                  class="f2 tc w-100"
                  :class="[getLocationFont(location.handle), themeSite == 'portal' || themeSite == 'shop' ? 'light' : 'color-2']"
                >{{ location.name }}</h4>
              </div>
            </div>
          </a>
          <a v-for="(restaurant, index) in restaurants" :href="restaurant.url" :key="index">
            <div class="aspect-ratio aspect-ratio--5x2">
              <div
                class="aspect-ratio--object flex items-center cover ph3"
                :style="{ backgroundImage: `url('${restaurant.imageMobile}')` }"
              >
                <h4
                  class="f2 tc w-100"
                  :class="[getLocationFont(restaurant.handle), themeSite == 'portal' || themeSite == 'shop' ? 'light' : 'color-2']"
                >{{ restaurant.name }}</h4>
              </div>
            </div>
          </a>
          <a v-if="webshop && sharedState.isCommerceInstalled" :href="webshop.url" :key="webshop.index">
            <div class="aspect-ratio aspect-ratio--5x2">
              <div class="aspect-ratio--object flex items-center cover bg-color-1 ph3">
                <h4 class="f2 tc w-100 color-2">{{ webshop.name }}</h4>
              </div>
            </div>
          </a>
        </div>

        <div v-else class="h-100 flex flex-column ph3 pt6">
          <ul class="list f1 color-2 shop-dark">
            <li v-for="(page, i) in pages" :key="i" class="mb3" data-menu-item>
              <a :href="page.url" :target="page.blank ? '_blank' : '_self'">{{ page.name }}</a>
            </li>
            <li v-if="webshop && sharedState.isCommerceInstalled" class="mb3" data-menu-item>
              <a :href="webshop.url">{{ webshop.name }}</a>
            </li>
          </ul>

          <div v-if="themeSite === 'shop'" class="pb3 mb4">
            <TagAutocomplete :focus="false" :theme-site="this.themeSite" :light-bg="this.lightBg" />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import s from "../store"
import { handleMenuOverlayEnter, handleMenuOverlayLeave } from "./MenuOverlay"
import TagAutocomplete from "./TagAutocomplete.vue"

export default {
  name: "MobileMenu",

  components: {
    TagAutocomplete
  },

  props: {
    pages: Array,
    locations: Array,
    restaurants: Array,
    webshop: Object,
    cartUrl: String,
    translations: Object,
    formAction: String,
    themeSite: String,
    lightBg: {
      type: String,
      default: "false"
    }
  },

  data() {
    return {
      sharedState: s.state,
      isOpen: false,
      showLocations: false
    }
  },

  methods: {
    toggle: function() {
      this.isOpen = !this.isOpen

      // eslint-disable-next-line
      console.log('comm', this.sharedState.isCommerceInstalled)

      const body = document.body
      const classString = "overflow-hidden"
      this.isOpen
        ? body.classList.add(classString)
        : body.classList.remove(classString)
    },

    toggleLocationList: function() {
      this.showLocations = !this.showLocations
    },

    onEnter: function(el, done) {
      handleMenuOverlayEnter(el, done)
    },

    onLeave: function(el, done) {
      handleMenuOverlayLeave(el, done)
    },

    getLocationFont: function(handle) {
      const locationFontMap = {
        portal_nl: "font-portal",
        portal_en: "font-portal",
        hotelv_fizeaustraat_nl: "font-fizeaustraat",
        hotelv_fizeaustraat_en: "font-fizeaustraat",
        hotelv_frederiksplein_nl: "font-frederiksplein",
        hotelv_frederiksplein_en: "font-frederiksplein",
        hotelv_nesplein_nl: "font-nesplein",
        hotelv_nesplein_en: "font-nesplein",
        lobby_fizeaustraat_nl: "font-fizeaustraat",
        lobby_fizeaustraat_en: "font-fizeaustraat",
        lobby_nesplein_nl: "font-nesplein",
        lobby_nesplein_en: "font-nesplein",
        webshop_nl: "font-shop",
        webshop_en: "font-shop"
      }
      return locationFontMap.hasOwnProperty(handle)
        ? locationFontMap[handle]
        : null
    }
  }
}
</script>
